export const SEARCH_HISTORY_URL = 'searchHistoryUrl'
export const SEARCH_SCROLL_POSITION = 'searchScrollPosition'
